import { render, staticRenderFns } from "./Appelfacture.vue?vue&type=template&id=678d81d7&"
import script from "./Appelfacture.vue?vue&type=script&lang=js&"
export * from "./Appelfacture.vue?vue&type=script&lang=js&"
import style0 from "./Appelfacture.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports